<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <mat-icon>close</mat-icon>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="statuses" formControlName="status" optionLabel="name" optionValue="value"
            placeholder="Status"></p-dropdown>
            <label for="Status">Status</label>
            @for (validation of validationMessages.status; track validation) {
              <span>
                @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small id="name2-help" class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="description" id="description" [rows]="5" pInputTextarea></textarea>
            <label for="description">Description</label>
            @for (validation of validationMessages.description; track validation) {
              <span>
                @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
              optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false"
              placeholder="Select Property">
            </p-dropdown>
            <label for="Select Property">Select Property</label>
            @for (validation of validationMessages.shortTermRentalId; track validation) {
              <span>
                @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>


        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="channelSourceIds" formControlName="channelProviderId" optionLabel="name" optionValue="value"
            placeholder="channelProviderId"></p-dropdown>
            <label for="channelProviderId">channelProviderId</label>
            @for (validation of validationMessages.channelProviderId; track validation) {
              <span>
                @if (form1.get('channelProviderId').hasError(validation.type) && (form1.get('channelProviderId').dirty || form1.get('channelProviderId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="propertyName" id="propertyName" type="text" pInputText>
            <label for="propertyName">Property Name</label>
            @for (validation of validationMessages.propertyName; track validation) {
              <span>
                @if (form1.get('propertyName').hasError(validation.type) && (form1.get('propertyName').dirty || form1.get('propertyName').touched)) {
                  <small id="propertyName2-help" class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="channelPropId" id="channelPropId" type="text" pInputText>
            <label for="channelPropId">ChannelPropId</label>
            @for (validation of validationMessages.channelPropId; track validation) {
              <span>
                @if (form1.get('channelPropId').hasError(validation.type) && (form1.get('channelPropId').dirty || form1.get('channelPropId').touched)) {
                  <small id="channelPropId2-help" class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <div class="w-100 mb-3">
            <h6 for="publishCalendar" class="font-medium">Publish Calendar</h6>
            <div class="flex align-items-center">
              <p-checkbox [formControl]="form1.controls['publishCalendar']" inputId="publishCalendar"
              [binary]="true"></p-checkbox>
              <span class="test-nm">Is Publish Calendar?</span>
            </div>
            @for (validation of validationMessages.publishCalendar; track validation) {
              <span>
                @if (form1.get('publishCalendar').hasError(validation.type) && (form1.get('publishCalendar').dirty || form1.get('publishCalendar').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>
        </div>

        <div class="col-lg-12">
          <div class="w-100 mb-3">
            <h6 for="publishAddress" class="font-medium">Publish Address</h6>
            <div class="flex align-items-center">
              <p-checkbox [formControl]="form1.controls['publishAddress']" inputId="publishAddress"
              [binary]="true"></p-checkbox>
              <span class="test-nm">Is Publish Address?</span>
            </div>
            @for (validation of validationMessages.publishAddress; track validation) {
              <span>
                @if (form1.get('publishAddress').hasError(validation.type) && (form1.get('publishAddress').dirty || form1.get('publishAddress').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>
        </div>

        <div class="col-lg-12">
          <div class="w-100 mb-3">
            <h6 for="acceptBookingsOnline" class="font-medium">Accept Bookings Online</h6>
            <div class="flex align-items-center">
              <p-checkbox [formControl]="form1.controls['acceptBookingsOnline']" inputId="acceptBookingsOnline"
              [binary]="true"></p-checkbox>
              <span class="test-nm">Is Accept Bookings Online?</span>
            </div>
            @for (validation of validationMessages.acceptBookingsOnline; track validation) {
              <span>
                @if (form1.get('acceptBookingsOnline').hasError(validation.type) && (form1.get('acceptBookingsOnline').dirty || form1.get('acceptBookingsOnline').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>
        </div>

        <div class="col-lg-12">
          <div class="w-100 mb-3"
            [ngStyle]="form1.get('syncEnabled').value === false ? {'background':'#fff3cd','border':'1px solid #ffc107','border-radius':'6px','padding':'12px'} : {}">
            <h6 class="font-medium">OTA Sync Enabled</h6>
            <div class="flex align-items-center gap-3">
              <p-inputSwitch [formControl]="form1.controls['syncEnabled']" inputId="syncEnabled"></p-inputSwitch>
              <span class="test-nm" style="font-weight:600;">
                @if (form1.get('syncEnabled').value === false) {
                  <span style="color:#856404;">⚠ Sync DISABLED — rates, availability &amp; inventory will NOT be pushed to this OTA channel</span>
                } @else {
                  <span>Sync enabled — property will be pushed to this OTA channel normally</span>
                }
              </span>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="rateAdjustmentPercent" id="rateAdjustmentPercent" type="number" pInputText>
            <label for="rateAdjustmentPercent">Rate Adjustment Percent</label>
            @for (validation of validationMessages.rateAdjustmentPercent; track validation) {
              <span>
                @if (form1.get('rateAdjustmentPercent').hasError(validation.type) && (form1.get('rateAdjustmentPercent').dirty || form1.get('rateAdjustmentPercents').touched)) {
                  <small id="rateAdjustmentPercent2-help" class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="rateAdjustmentAmount" id="rateAdjustmentAmount" type="number" pInputText>
            <label for="rateAdjustmentAmount">Rate Adjustment Amount</label>
            @for (validation of validationMessages.rateAdjustmentAmount; track validation) {
              <span>
                @if (form1.get('rateAdjustmentAmount').hasError(validation.type) && (form1.get('rateAdjustmentAmount').dirty || form1.get('rateAdjustmentAmount').touched)) {
                  <small id="rateAdjustmentAmount2-help" class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="flatFeeAdjustmentAmount" id="flatFeeAdjustmentAmount" type="number"
              pInputText>
            <label for="flatFeeAdjustmentAmount">Flat Fee Adjustment Amount</label>
            @for (validation of validationMessages.flatFeeAdjustmentAmount; track validation) {
              <span>
                @if (form1.get('flatFeeAdjustmentAmount').hasError(validation.type) && (form1.get('flatFeeAdjustmentAmount').dirty || form1.get('flatFeeAdjustmentAmount').touched)) {
                  <small id="flatFeeAdjustmentAmount2-help" class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="dailyFeeAdjustmentAmount" id="dailyFeeAdjustmentAmount" type="number"
              pInputText>
            <label for="dailyFeeAdjustmentAmount">Daily Fee Adjustment Amount</label>
            @for (validation of validationMessages.dailyFeeAdjustmentAmount; track validation) {
              <span>
                @if (form1.get('dailyFeeAdjustmentAmount').hasError(validation.type) && (form1.get('dailyFeeAdjustmentAmount').dirty || form1.get('dailyFeeAdjustmentAmount').touched)) {
                  <small id="dailyFeeAdjustmentAmount2-help" class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="channelListingStatus" id="channelListingStatus" type="text" pInputText>
            <label for="channelListingStatus">Channel Listing Status</label>
            @for (validation of validationMessages.channelListingStatus; track validation) {
              <span>
                @if (form1.get('channelListingStatus').hasError(validation.type) && (form1.get('channelListingStatus').dirty || form1.get('channelListingStatus').touched)) {
                  <small id="name2-help" class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="channelRateStatus" id="channelRateStatus" type="text" pInputText>
            <label for="channelRateStatus">Channel Rate Status</label>
            @for (validation of validationMessages.channelRateStatus; track validation) {
              <span>
                @if (form1.get('channelRateStatus').hasError(validation.type) && (form1.get('channelRateStatus').dirty || form1.get('channelRateStatus').touched)) {
                  <small id="name2-help" class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="channelAvailStatus" id="channelAvailStatus" type="text" pInputText>
            <label for="channelAvailStatus">Channel Avail Status</label>
            @for (validation of validationMessages.channelAvailStatus; track validation) {
              <span>
                @if (form1.get('channelAvailStatus').hasError(validation.type) && (form1.get('channelAvailStatus').dirty || form1.get('channelAvailStatus').touched)) {
                  <small id="name2-help" class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="channelContentStatus" id="channelContentStatus" type="text" pInputText>
            <label for="channelContentStatus">Channel Content Status</label>
            @for (validation of validationMessages.channelContentStatus; track validation) {
              <span>
                @if (form1.get('channelContentStatus').hasError(validation.type) && (form1.get('channelContentStatus').dirty || form1.get('channelContentStatus').touched)) {
                  <small id="name2-help" class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (channelId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete Channel</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!channelId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add Channel</button>
              }

              @if (channelId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Channel</button>
              }
            </div>
          </div>
        </div>
      </div>

    </div>